import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import { domainToRegex } from "../urlPatternConversion";
import logo from "./logo.svg";

export const syncthing = defineConnector({
  identifier: "syncthing",
  name: "Syncthing",
  tagLine: "Continuous file synchronization",
  logo,
  protocol: "http",
  tags: ["it"],
  defaultUrlPattern: ({ instanceUrl }) => domainToRegex(instanceUrl),
  auth: (app) => headerAuth([{ name: "X-API-Key", value: app.secret.apiKey }]),
  steps: [
    {
      title: "Enter your Syncthing details",
      items: [
        {
          kind: "baseUrl",
          label: "Server URL",
          required: true,
          placeholder: "https://syncthing.example.com:8384",
          target: { kind: "configuration", field: "instanceUrl" },
          helperText: "The base URL of your Syncthing GUI.",
        },
      ],
    },
    {
      title: "Get your API key",
      items: [
        {
          kind: "markdown",
          content:
            "In Syncthing, go to **Actions → Settings → GUI** and copy the **API key**.",
        },
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ instanceUrl }) => `${instanceUrl}/rest/system/ping`,
  },
});
